import { useRouter } from 'vue-router';
/**
 * When rendering anchor tags from an external source, vue does not know these are internal links.
 * The href directs the user outside of the vue-router context and is not treated like a SPA link (page hard reloads).
 *
 * @property {HTMLElement[]} elementRef - The element you want to span for anchor tags
 */
export default function useVueLinks(elementRef: HTMLElement, router?): void {
    if (!router) router = useRouter();

    if (!elementRef) return;
    [...elementRef.getElementsByTagName('a')].forEach((link) => {
        if (link.host === window.location.host && router) {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                const route = link?.getAttribute('href');
                if (route) router.push(route);
            });
        } else if (link.host !== window.location.host) {
            link.target = '_blank';
        }
    });
}
